import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
// import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { TripVerificationIcon } from "../../components/icons/CustomIcons";
import ROUTES_PATH from "../routes";
export const mainSidebarItems = [
  {
    id: 1,
    icon: <DashboardOutlinedIcon />,
    label: "Dashboard",
    path: "/admin/dashboard",
  },
  {
    id: 7,
    icon: <TripVerificationIcon />,
    label: "Trip Verification Queue",
    path: "/admin/trip-verification",
  },
  {
    id: 8,
    icon: <EmojiEventsOutlinedIcon />,
    label: "Manage Challenges",
    path: "/admin/manage-challenges",
  },
  {
    id: 9,
    icon: <AccessTimeOutlinedIcon />,
    label: "User Challenge Activity",
    path: ROUTES_PATH.USER_CHALLENGE_ACTIVITY,
  },
  {
    id: 10,
    icon: <NotificationsNoneOutlinedIcon />,
    label: "Notifications",
    path: ROUTES_PATH.NOTIFICATIONS,
  },
  {
    id: 2,
    icon: <GroupOutlinedIcon />,
    label: "Users",
    path: "/admin/users",
  },
  {
    id: 3,
    icon: <TopicOutlinedIcon />,
    label: "Resources",
    path: "/admin/resources",
  },
  // {
  //   id: 4,
  //   icon: <SupportAgentOutlinedIcon />,
  //   label: "Support",
  //   path: "/admin/support",
  // },
  {
    id: 5,
    icon: <QuestionAnswerOutlinedIcon />,
    label: "FAQ",
    path: "/admin/faq",
  },
  {
    id: 6,
    icon: <NotificationsActiveOutlinedIcon />,
    label: "Notification Settings",
    path: "/admin/notification",
  },
];
